import {AWS_DOMAIN} from '../../constants/global';

/**
 * retrieves temp aws credentials (users' unique catapult id)
 * @return {string} catapult id
 */
export const catapultId = () => cb.core.iam.getTempAWSCredsSubject();

/**
 * retrieves current users' first name
 * @return {string} first name
 */
export const firstName = () => cb.core.iam.getAuthSession().basicProfile.firstName;

/**
 * retrieves an aws token for the provided domain
 * @param {string} domain dmoain name
 * @return {string} aws token
 */
export const getAWSToken = domain => cb.core.iam.getTempAWSCreds(domain || AWS_DOMAIN);

/**
 * retrieves cb's iam events
 * @return {object} iam events
 */
export const getIamEvents = () => cb.core.iam.events;

/**
 * retrieves users' current jwt token
 * @return {string} jwt token
 */
export const getJWTToken = () => cb.core.iam.getJWTToken();

/**
 * retrieves access to aws lambda functions
 * @param {object} credentials credentials to provide to aws
 * @return {object} lambda access
 */
export const getLambdaAccess = credentials => new AWS.Lambda({credentials});

/**
 * retrieves current users' authentication status
 * @return {boolean} denotes if user is authenticated
 */
export const isLoggedIn = () => cb.core.iam.getAuthSession().isLoggedIn;

/**
 * retrieves iam event bus and adds a listener for a specific event
 * @param {string} event iam event to listen for
 * @param {function} action function to be executed upon event occuring
 */
export const onIamEvent = (event, action) => cb.core.iam.getEventBus().on(event, action);

/**
 * retrieves current users' session id
 * @return {string} session id
 */
export const sessionId = () => cb.core.iam.getAuthSession().sessionId;

/**
 * retrieves current users' username
 * @return {string} username
 */
export const userName = () => cb.core.iam.getAuthSession().basicProfile.userName;
